import {
  ListSubheader,
} from '@mui/material';
import React, {useContext, useEffect, useState} from "react";
import {FormDataContext} from "../../contexts/FormDataContext";
import { SectionHeading } from '../SectionHeading';
import { IntakeAutocomplete } from '../IntakeAutocomplete';


export const OccupationsAutocomplete = () => {
  const [occupationItems, setOccupationItems] = useState([]);

  const {
    occupations,
    selectedOccupations,
    setSelectedOccupations,
    preferencesFormDisabled,
  } = useContext(FormDataContext);

  useEffect(() => {
    if (occupations.length > 0) {
      // Sort Occupations alphabetically for each Career Area.
      occupations.forEach(careerAreas => {
        careerAreas.codes.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      });
      setOccupationItems(
        occupations.flatMap(group => group.codes.map(code => ({
          ...code,
          groupName: group.name
        })))
      );
    }
  }, [occupations]);

  return (
    <>
      <SectionHeading>
        Career Fields You Are Interested In
      </SectionHeading>
      {occupationItems.length > 0 &&
        <IntakeAutocomplete
          label="occupations"
          options={occupationItems}
          selectedTaxonomyTermIds={selectedOccupations}
          setSelectedTaxonomyTermIds={setSelectedOccupations}
          optionIdPropertyName="code_id"
          disabled={preferencesFormDisabled}
          groupBy={(option) => option.groupName}
          renderGroup={({ key, group, children }) => (
            <li key={`${group.replace(/\W+/g,'')}${key}`}>
              <ul style={{margin: 0, padding: 0}}>
                <ListSubheader style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>
                  {group}
                </ListSubheader>
                {children}
              </ul>
            </li>
          )}
        />
      }
    </>
  );

};
